import { Box, Card, CardContent, CardHeader, Container, Grid, SxProps, Typography } from "@mui/material"
import * as React from "react";
import { Link } from 'react-router-dom';
import { AdminRoutes } from "../../constants/routes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine, faUsers, faHandshake, faPenField} from "@fortawesome/pro-solid-svg-icons";
import AdminNavigation from "./AdminNavigation";
import { faBird, faFileCertificate, faAddressCard } from "@fortawesome/pro-duotone-svg-icons";

const cardStyleProps: SxProps = {
    '&:hover': {
        backgroundColor: '#ededed',
        cursor: 'pointer'
    },
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
}

const AdminHome: React.FunctionComponent = () => {
    return (
        <Box>
            <AdminNavigation/>
            <Box>
                <Container
                    maxWidth="lg"
                >
                    <Box
                        sx={{
                            px: {
                                xs: 1
                            },
                            my: {
                                xs: 3
                            }
                        }}
                    >
                        <Grid
                            container
                            spacing={12}
                            alignItems="stretch"
                            justifyContent="center"
                        >
                            <Grid
                                item
                                xs={8}
                                sm={6}
                                md={4}
                                lg={3}
                            >

                                <Link
                                    to={AdminRoutes.ADMIN_REGISTRATIONS}
                                    style={{ textDecoration: 'none' }}
                                >
                                    <Card
                                        sx={{
                                            ...cardStyleProps
                                        }}
                                    >
                                        <CardHeader
                                            title={
                                                <Typography
                                                    variant="h3"
                                                    gutterBottom
                                                    textAlign="center"
                                                    color="#502d77"
                                                >
                                                    Registrations
                                                </Typography>
                                            }
                                        />
                                        <CardContent>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    color: 'primary.main'
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    size="4x"
                                                    fixedWidth
                                                    icon={faUsers}
                                                />
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Link>
                            </Grid>






                            <Grid
                                item
                                xs={8}
                                sm={6}
                                md={4}
                                lg={3}
                            >

                                <Link
                                    to={AdminRoutes.ADMIN_SPONSOR} /// bla
                                    style={{ textDecoration: 'none' }}
                                >
                                    <Card
                                        sx={{
                                            ...cardStyleProps
                                        }}
                                    >
                                        <CardHeader
                                            title={
                                                <Typography
                                                    variant="h3"
                                                    gutterBottom
                                                    textAlign="center"
                                                    color="#502d77"
                                                >
                                                    Sponsors
                                                </Typography>
                                            }
                                        />
                                        <CardContent>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    color: 'primary.main'
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    size="4x"
                                                    fixedWidth
                                                    icon={faHandshake}
                                                />
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Link>
                            </Grid>



                            <Grid
                                item
                                xs={8}
                                sm={6}
                                md={4}
                                lg={3}
                            >

                                <Link
                                    to={AdminRoutes.ADMIN_SPEAKER} /// bla
                                    style={{ textDecoration: 'none' }}
                                >
                                    <Card
                                        sx={{
                                            ...cardStyleProps
                                        }}
                                    >
                                        <CardHeader
                                            title={
                                                <Typography
                                                    variant="h3"
                                                    gutterBottom
                                                    textAlign="center"
                                                    color="#502d77"
                                                >
                                                    Custom Registrations
                                                </Typography>
                                            }
                                        />
                                        <CardContent>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    color: 'primary.main'
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    size="4x"
                                                    fixedWidth
                                                    icon={faPenField}
                                                />
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Link>
                            </Grid>





                            <Grid
                                item
                                xs={8}
                                sm={6}
                                md={4}
                                lg={3}
                            >
                                <Link
                                    to={AdminRoutes.ADMIN_CERTIFICATES}
                                    style={{ textDecoration: 'none' }}
                                >
                                    <Card
                                        sx={{
                                            ...cardStyleProps
                                        }}
                                    >
                                        <CardHeader
                                            title={
                                                <Typography
                                                    variant="h4"
                                                    gutterBottom
                                                    textAlign="center"
                                                >
                                                    Certificates
                                                </Typography>
                                            }
                                        />
                                        <CardContent>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    color: 'primary.main'
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    size="4x"
                                                    fixedWidth
                                                    icon={faFileCertificate}
                                                />
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Link>
                            </Grid>

                            <Grid
                                item
                                xs={8}
                                sm={6}
                                md={4}
                                lg={3}

                            >
                                <Link
                                    to={AdminRoutes.ADMIN_REPORTS}
                                    style={{ textDecoration: 'none' }}
                                >
                                    <Card
                                        sx={{
                                            ...cardStyleProps
                                        }}
                                    >
                                        <CardHeader
                                            title={
                                                <Typography
                                                    variant="h3"
                                                    gutterBottom
                                                    textAlign="center"
                                                    color="#502d77"
                                                >
                                                    Reports
                                                </Typography>
                                            }
                                        />
                                        <CardContent>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    color: 'primary.main'
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    size="4x"
                                                    fixedWidth
                                                    icon={faChartLine}
                                                />
                                            </Box>
                                        </CardContent>
                                        
                                    </Card>
                                </Link>
                                
                            </Grid>
                             <Grid
                                item
                                xs={8}
                                sm={6}
                                md={4}
                                lg={3}

                            >
                                <Link
                                    to={AdminRoutes.ADMIN_PRINTING}
                                    style={{ textDecoration: 'none' }}
                                >
                                    <Card
                                        sx={{
                                            ...cardStyleProps
                                        }}
                                    >
                                        <CardHeader
                                            title={
                                                <Typography
                                                    variant="h3"
                                                    gutterBottom
                                                    textAlign="center"
                                                    color="#502d77"
                                                >
                                                    Badge Printing
                                                </Typography>
                                            }
                                        />
                                        <CardContent>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    color: 'primary.main'
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    size="4x"
                                                    fixedWidth
                                                    icon={faAddressCard}
                                                />
                                            </Box>
                                        </CardContent>
                                        
                                    </Card>
                                </Link>
                                
                            </Grid>

                            <Grid
                                item
                                xs={8}
                                sm={6}
                                md={4}
                                lg={3}

                            >
                                <a 
        href='/report/early-bird-export' 
        style={{ textDecoration: 'none' }}
    >
        <Card
            sx={{
                ...cardStyleProps,
            }}
        >
            <CardHeader
                title={
                    <Typography
                        variant="h3"
                        gutterBottom
                        textAlign="center"
                        color="#502d77"
                    >
                        Export {new Date().getFullYear() + 1} Registrations
                    </Typography>
                }
            />
            <CardContent>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'primary.main'
                    }}
                >
                    <FontAwesomeIcon
                        size="4x"
                        fixedWidth
                        icon={faBird}
                    />
                </Box>
            </CardContent>
        </Card>
    </a>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>
            </Box>
        </Box>
    )
}

export default AdminHome